import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router-dom';
import IRestError from 'src/app/data/common/interfaces/IRestError';
import AuthStatus from 'src/app/redux/modules/auth/interfaces/AuthStatus';
import selectors from 'src/app/redux/selectors';
import { IAppState } from 'src/app/redux/store/reducers';
import ROUTE_PATHS from 'src/routing/paths';
import Login from './Login';
import * as H from 'history';
import getUrlParamValue from 'src/app/data/common/utils/queryParamsAccessor';

export interface ILoginContainerProps extends RouteComponentProps {
  errors: IRestError[] | null;
  status: AuthStatus;
  location: H.Location<{ from: H.Location }>;
}

class LoginContainer extends React.Component<ILoginContainerProps> {

  public state = {
    redirectToReferrer: false,
  };

  public componentDidMount() {
    // Redirect to Home page if a user has already logged in
    this.redirectToReferrerIfNeeded();
  }

  public componentDidUpdate(prevProps: ILoginContainerProps) {
    // Redirect to referrer on successful login
    if (prevProps.status !== this.props.status) {
      this.redirectToReferrerIfNeeded();
    }
  }

  public render() {
    const { from } = this.props.location && this.props.location.state || { from: { pathname: ROUTE_PATHS.HOME } };

    if (this.state.redirectToReferrer) {

      const ltiRedirectionQueryParam = getUrlParamValue('to', this.props.location);
      const scenarioIdQueryParam = getUrlParamValue('scenarioId', this.props.location);
      const decodedUrl = ltiRedirectionQueryParam ? decodeURIComponent(ltiRedirectionQueryParam) : null;
      const ltiRedirectionPath = decodedUrl ? new URL(ltiRedirectionQueryParam, window.location.origin) : null;
      if (ltiRedirectionPath) {
        const scenarioId = scenarioIdQueryParam ? '&scenarioId=' + scenarioIdQueryParam  :  '';
        sessionStorage.setItem('link', ltiRedirectionPath?.pathname+ltiRedirectionPath?.search  + scenarioId);
      }
      // prevent cycled redirection to the login page
      if (from.pathname === this.props.location.pathname) {
        from.pathname = ROUTE_PATHS.HOME;
      }

      return <Redirect to={{
        ...from,
        state: {
          from: this.props.location,
        },
      }}/>;
    }

    const error = this.props.errors ? this.props.errors[0].message : undefined;
    const authProcessing = this.props.status === AuthStatus.AUTHENTICATION_PROCESS;

    return (
      <Login
        enableToEditForm={!authProcessing}
        error={error}
        redirectUrl={from.pathname + from.search}
      />
    );
  }

  private redirectToReferrerIfNeeded() {
    if (this.props.status !== AuthStatus.AUTHENTICATION_SUCCESSFUL) {
      return;
    }

    this.setState({
      redirectToReferrer: true,
    });
  }
}

export default withRouter(connect(
  (state: IAppState) => ({
    errors: selectors.auth.getAuthErrors(state),
    status: selectors.auth.getAuthStatus(state),
  }),
)(LoginContainer));
